export const columns = [
  { id: 'phone', label: 'Telefone', minWidth: 250 },
  { id: 'type', label: 'Tipo', minWidth: 100 },
  { id: 'updatedAt', label: 'Data de atualização', minWidth: 200 },
  { id: 'actions', label: 'Ações', minWidth: 50 }
]
